var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6 0.788574C5.97262 0.788574 0.600037 6.16116 0.600037 12.7886C0.600037 19.416 5.97262 24.7886 12.6 24.7886C19.2275 24.7886 24.6 19.416 24.6 12.7886C24.6 6.16116 19.2275 0.788574 12.6 0.788574ZM13.8508 13.3157V19.8443H11.1496V13.3159H9.80004V11.0661H11.1496V9.71536C11.1496 7.87997 11.9116 6.78857 14.0766 6.78857H15.8791V9.03863H14.7524C13.9096 9.03863 13.8539 9.35304 13.8539 9.93983L13.8508 11.0659H15.8918L15.653 13.3157H13.8508Z",
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.ee4d747214a8712f649f0585dee85177.svg";
export { ForwardRef as ReactComponent };